import { UpdatesNavigation } from './navigation'
import { UpdatesScreens } from './screens'
import { UpdatesStatsig } from './statsig'

export const Updates = {
  Screens: UpdatesScreens,
  Statsig: UpdatesStatsig,
  Navigation: UpdatesNavigation,
  Icons: {},
}
